import styled from "styled-components";

export const SpinContainer = styled.div`
  padding: 187px 0;
  text-align: center;
`;
